module.exports = __webpack_public_path__ + "static/story3-thumbnails-rect-250x125-9cb6d12ec3e5256e4edd38787c964cac.jpg";